module.exports = __webpack_public_path__ + "img/caigou.09ad33d0.png";